import { twMerge } from "tailwind-merge";

interface CustomButtonLinkProps {
  to: string;
  text: string;
  openInNewTab?: boolean;
  className?: string;
  iconClassName?: string;
}

export const CustomButtonLink = ({
  to,
  text,
  openInNewTab = false,
  className,
  iconClassName,
}: CustomButtonLinkProps) => {
  return (
    <a
      className={twMerge(
        "text-white px-3 py-2 bg-primary text-sm font-bold no-underline rounded-sm",
        className
      )}
      rel={openInNewTab ? "noopener noreferrer" : undefined}
      target={openInNewTab ? "_blank" : undefined}
      href={to}
    >
      {iconClassName && (
          <i className={iconClassName} />
      )}
      {text}
    </a>
  );
};
